import { IconProps } from "../../../types/style";

const ShieldTickSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M19.0398 4.11984L13.5398 2.05984C12.9698 1.84984 12.0398 1.84984 11.4698 2.05984L5.9698 4.11984C4.9098 4.51984 4.0498 5.75984 4.0498 6.88984V14.9898C4.0498 15.7998 4.5798 16.8698 5.2298 17.3498L10.7298 21.4598C11.6998 22.1898 13.2898 22.1898 14.2598 21.4598L19.7598 17.3498C20.4098 16.8598 20.9398 15.7998 20.9398 14.9898V6.88984C20.9498 5.75984 20.0898 4.51984 19.0398 4.11984ZM15.9798 9.71984L11.6798 14.0198C11.5298 14.1698 11.3398 14.2398 11.1498 14.2398C10.9598 14.2398 10.7698 14.1698 10.6198 14.0198L9.0198 12.3998C8.7298 12.1098 8.7298 11.6298 9.0198 11.3398C9.3098 11.0498 9.7898 11.0498 10.0798 11.3398L11.1598 12.4198L14.9298 8.64984C15.2198 8.35984 15.6998 8.35984 15.9898 8.64984C16.2798 8.93984 16.2798 9.42984 15.9798 9.71984Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default ShieldTickSVG;
